// extracted by mini-css-extract-plugin
module.exports = {"Container":"Home_Container__C2c83","Content_Container":"Home_Content_Container__1EBpj","Tagline_Container":"Home_Tagline_Container__pW6iq","Tagline":"Home_Tagline__1WDfJ"};